const TravelReportAttachmentView = (props) => {
  return (
    <div className="travel-report-attachment-view">
      <img src={props.imageUrl} alt="" />
    </div>
  );
};

export default TravelReportAttachmentView;
